import React from 'react'
import { LABELS } from '../../constants/staticText'
import groupByInitial from '../../../client/functions/groupByInitial'

// A–Z-Filter wie heute — nur clientseitig, ohne Netzverkehr. Benannt, damit
// er sich von den anderen Navigationen der Seite unterscheidet (#236).
const AzFilter = ({ items, labelKey = 'name', active, onSelect }) => {
    const letters = groupByInitial(items, labelKey).map(g => g.letter)

    return (
        <nav className="az-filter" aria-label={LABELS.azFilter}>
            <button type="button" className={!active ? 'is-active' : ''} aria-pressed={!active} onClick={() => onSelect('')}>
                {LABELS.filterAll}
            </button>
            {letters.map(letter => (
                <button
                    key={letter}
                    type="button"
                    className={letter === active ? 'is-active' : ''}
                    aria-pressed={letter === active}
                    onClick={() => onSelect(letter)}
                >{letter}</button>
            ))}
        </nav>
    )
}

export default AzFilter
